/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component } from '@angular/core';
import {
  TasksListComponent
} from '../../../../../../libs/delivery-libs/task-management/shared-ui/src/lib/tasks-list/tasks-list.component';

@Component({
  selector: 'well-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
  standalone: true,
  imports: [TasksListComponent]
})
export class PlaygroundComponent{

}
